// Durable IAP entitlements (non-consumables). Heart packs stay on the
// heart battery and are not stored here.

export const LS_IAP_ENTITLEMENTS_KEY = "mmu_iap_entitlements_v1";

export function createEmptyIapEntitlements() {
    return {
        noAds: false,
    };
}

export function normalizeIapEntitlements(raw = null) {
    if (!raw || typeof raw !== "object") {
        return createEmptyIapEntitlements();
    }

    return {
        noAds: Boolean(raw.noAds),
    };
}

export function mergeIapEntitlements(localState = null, accountState = null) {
    const local = normalizeIapEntitlements(localState);
    const account = normalizeIapEntitlements(accountState);

    return {
        noAds: Boolean(local.noAds || account.noAds),
    };
}

export function grantNoAdsEntitlement(state = null) {
    return {
        ...normalizeIapEntitlements(state),
        noAds: true,
    };
}

export function loadIapEntitlements() {
    try {
        const raw = window.localStorage.getItem(LS_IAP_ENTITLEMENTS_KEY);
        if (!raw) {
            return createEmptyIapEntitlements();
        }
        return normalizeIapEntitlements(JSON.parse(raw));
    } catch {
        return createEmptyIapEntitlements();
    }
}

export function saveIapEntitlements(state = null) {
    try {
        window.localStorage.setItem(
            LS_IAP_ENTITLEMENTS_KEY,
            JSON.stringify(normalizeIapEntitlements(state))
        );
    } catch {
        // ignore localStorage failures
    }
}
